// Klaviyo popup triggers.
//
// Any element with data-klaviyo-open-form="<form ID>" opens that Klaviyo form
// on click (the form must be set to display via "custom trigger" in Klaviyo).
// Uses Klaviyo's onsite queue, so a click before the Klaviyo app embed has
// loaded is queued and the popup opens once it is ready. One delegated
// listener, so buttons re-rendered by the theme editor keep working.
if (!window.DigitalizModules) window.DigitalizModules = {};
if (!window.DigitalizModules.KlaviyoPopup) {
  class KlaviyoPopup {
    constructor() {
      this.onClick = (event) => this.handleClick(event);
      this.init();
    }

    init() {
      document.addEventListener("click", this.onClick);
    }

    handleClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const trigger = target.closest("[data-klaviyo-open-form]");
      if (!trigger) return;
      const formId = (trigger.getAttribute("data-klaviyo-open-form") || "").trim();
      if (!formId) return;

      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
    }

    destroy() {
      document.removeEventListener("click", this.onClick);
    }
  }

  window.DigitalizModules.KlaviyoPopup = new KlaviyoPopup();
}
